<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <el-form :inline="true" ref="form" :model="form" label-width="100px">
      <el-form-item label="设备编号">
        <el-input
          clearable
          v-model="form.equipmentNum"
          placeholder="请输入设备编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户手机号">
        <el-input
          clearable
          v-model="form.phone"
          placeholder="请输入用户手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select clearable v-model="form.status" placeholder="全部">
          <el-option label="待审核" value="0"></el-option>
          <el-option label="已通过" value="1"></el-option>
          <el-option label="已驳回" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间" label-width="110px">
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">查询</el-button>
        <el-button>重置</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
    <!-- 表格 -->
    <el-table
      class="mgt-15"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="date" label="设备名称"> </el-table-column>
      <el-table-column prop="name" label="设备型号"> </el-table-column>
      <el-table-column prop="address" label="设备编号"> </el-table-column>
      <el-table-column prop="address" label="所属分区"> </el-table-column>
      <el-table-column prop="address" label="铺设地址"> </el-table-column>
      <el-table-column prop="address" label="用户手机号"> </el-table-column>
      <el-table-column prop="address" label="申请时间"> </el-table-column>
      <el-table-column prop="address" label="审核状态"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 详情弹框 -->
    <el-dialog
      title="详情"
      :visible.sync="detailVisible"
      width="25%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>申请人</span>
        <span>###</span>
      </div>
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>申请时间</span>
        <span>###</span>
      </div>
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>解绑备注</span>
        <span>###</span>
      </div>
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>审核状态</span>
        <span>###</span>
      </div>
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>审核备注</span>
        <span>###</span>
      </div>
      <div class="flex aic jcsb fw-600 mgb-15">
        <span>审核时间</span>
        <span>###</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
    <!-- 审核弹框 -->
    <el-dialog
      title="审核"
      :visible.sync="checkVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        ref="checkForm"
        :rules="rules"
        :model="checkForm"
        label-width="80px"
      >
        <el-form-item label="备注" prop="desc">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            v-model="checkForm.desc"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="checkVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="checkVisible = false">{{
          funTit == "pass" ? "通 过" : "驳 回"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      funTit: null,
      multipleSelection: [],
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      detailVisible: false,
      checkVisible: false,
      checkForm: { desc: "" },
      rules: {
        desc: [
          { required: true, message: "请输入备注", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    // 列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
    },
    pass() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.checkForm = { desc: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.checkForm.clearValidate();
      });
      this.checkForm = true;
    },
    turndown() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.checkForm = { desc: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.checkForm.clearValidate();
      });
      this.checkForm = true;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
